import { useEffect, useState } from 'react';
import logo from '../../assets/logo.png';

const sections = [
  { id: 'home', label: 'Home' },
  { id: 'services', label: 'Services' },
  { id: 'success-stories', label: 'Success Stories' },
  { id: 'about', label: 'About Us' },
];

export const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  const [isNavOpen, setIsNavOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);

      const viewportHeight = window.innerHeight;
      const threshold = viewportHeight * 0.3;

      for (const section of sections) {
        const element = document.getElementById(section.id);
        if (!element) {
          continue;
        }
        const rect = element.getBoundingClientRect();
        if (rect.top <= threshold && rect.bottom >= threshold) {
          setActiveSection(section.id);
          break;
        }
      }
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleNav = () => setIsNavOpen((prev) => !prev);
  const closeNav = () => setIsNavOpen(false);

  const handleLinkClick = (event, targetId) => {
    event.preventDefault();
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      const offsetTop = targetElement.offsetTop - 70;
      window.scrollTo({ top: offsetTop, behavior: 'smooth' });
      setActiveSection(targetId);
    }

    closeNav();
  };

  return (
    <header className={`site-header ${isScrolled ? 'is-scrolled' : ''}`}>
      <div className="container">
        <div className="site-nav">
          <a
            className="brand"
            href="#home"
            onClick={(event) => handleLinkClick(event, 'home')}
            aria-label="Wedding Tech Home"
          >
            <img src={logo} alt="Wedding Tech" className="brand-mark" />
          </a>
          <button
            className="nav-toggle"
            type="button"
            aria-label="Toggle navigation menu"
            aria-expanded={isNavOpen}
            onClick={toggleNav}
          >
            <span />
            <span />
            <span />
          </button>
          <nav className={`nav-links ${isNavOpen ? 'is-open' : ''}`} aria-label="Main navigation">
            {sections.map((section) => (
              <a
                key={section.id}
                className={`nav-link ${activeSection === section.id ? 'is-active' : ''}`}
                href={`#${section.id}`}
                onClick={(event) => handleLinkClick(event, section.id)}
              >
                {section.label}
              </a>
            ))}
          </nav>
        </div>
      </div>
      {isNavOpen ? <div className="nav-scrim" onClick={closeNav} aria-hidden="true" /> : null}
    </header>
  );
};
